<ion-card>
  <ion-card-header>
    <ion-card-title>Iktatás</ion-card-title>
    <ion-card-subtitle>
      Új főszám vagy alszám meglévő ügyirathoz. A sorszámot a szerver osztja ki
      tranzakcióban – kiosztott iktatószám soha nem kerül újra kiadásra.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <!-- Eredmény -->
    <div *ngIf="eredmeny" class="ikt-eredmeny">
      <div>
        <b class="iktszam">{{ eredmeny.iktatoszam }}</b>
        <span> · ügyirat: {{ eredmeny.ugyirat_iktatoszam }} · {{ eredmeny.alszam }}. alszám</span>
      </div>
      <div class="ikt-gombsor">
        <ion-button size="small" (click)="iratra()">Irat megnyitása</ion-button>
        <ion-button size="small" fill="outline" (click)="ugyiratra()">Ügyirat</ion-button>
        <ion-button size="small" fill="clear" (click)="ujra()">Új iktatás</ion-button>
      </div>
    </div>

    <ng-container *ngIf="!eredmeny">
      <!--  AZ IRÁNY A LEGFONTOSABB DÖNTÉS ezen a képernyőn, ezért nem jelölő-csempe
            többé: ott egyforma volt a „Digitális"-sal, és a kollégák nem találták meg,
            hol lehet kimenőt iktatni. Itt látszik, melyik van kiválasztva. -->
      <div class="ikt-irany">
        <span class="ikt-irany-cimke">Irány</span>
        <ion-segment [(ngModel)]="urlap.irany" (ionChange)="iranyValt()">
          <ion-segment-button value="be"><ion-label>Bejövő</ion-label></ion-segment-button>
          <ion-segment-button value="ki"><ion-label>Kimenő / belső</ion-label></ion-segment-button>
        </ion-segment>
      </div>

      <!-- Állapotjelölők -->
      <div class="ikt-jelolok">
        <span class="ikt-jelolo zold" [class.aktiv]="mod === 'foszam'"
              (click)="mod = 'foszam'">Főszámos</span>
        <span class="ikt-jelolo zold" [class.aktiv]="mod === 'alszam'"
              (click)="mod = 'alszam'">Alszámos</span>
        <span class="ikt-jelolo zold" [class.aktiv]="urlap.digitalis"
              (click)="urlap.digitalis = !urlap.digitalis">Digitális</span>
        <span class="ikt-jelolo piros" [class.aktiv]="urlap.rendelkezesi_nyilvantartas"
              (click)="urlap.rendelkezesi_nyilvantartas = !urlap.rendelkezesi_nyilvantartas">
          Rendelkezési nyilvántartás
        </span>
        <span class="ikt-jelolo zold" [class.aktiv]="urlap.bksz"
              (click)="urlap.bksz = !urlap.bksz" title="A küldemény a BKSZ kézbesítési sorába kerül">BKSZ</span>
        <span class="ikt-jelolo piros" [class.aktiv]="urlap.elektronikusan_kiadmanyozando"
              (click)="urlap.elektronikusan_kiadmanyozando = !urlap.elektronikusan_kiadmanyozando">
          Elektronikusan kiadmányozandó
        </span>
      </div>

      <ion-segment [(ngModel)]="ful" mode="ios">
        <ion-segment-button value="iktatas"><ion-label>Iktatás</ion-label></ion-segment-button>
        <ion-segment-button value="kiegeszito"><ion-label>Kiegészítő adatok</ion-label></ion-segment-button>
      </ion-segment>

      <ng-container *ngIf="ful === 'iktatas'">
        <div class="ikt-oszlopok">
          <!-- Bal oszlop -->
          <div>
            <h4>Irat alapadatai</h4>
            <div class="ikt-mezosor">
              <ion-select label="Iktatókönyv" label-placement="stacked" interface="popover"
                          *ngIf="mod === 'foszam'" [(ngModel)]="urlap.konyv">
                <ion-select-option *ngFor="let k of konyvek" [value]="k.id">
                  {{ k.jel }} – {{ k.nev }} ({{ k.ev }})
                </ion-select-option>
              </ion-select>
              <!--  ELŐZMÉNY. A bejövő igazolás ide kötődik: alszámként kerül az eredeti
                    ügyirathoz. Kereshető, és NEM csak a folyamatban lévőket kínálja –
                    egy igazolás jellemzően már lezárt ügyhöz érkezik. -->
              <div class="ikt-elozmeny" *ngIf="mod === 'alszam'">
                <ion-input label="Előzmény keresése" label-placement="stacked" fill="outline"
                           placeholder="Iktatószám, tárgy vagy a személy neve"
                           [(ngModel)]="elozmenyKereses" (ionInput)="elozmenyKeres()"></ion-input>
                <ion-select label="Ügyirat (főszám)" label-placement="stacked" interface="popover"
                            [(ngModel)]="urlap.ugyirat" (ionChange)="ugyiratValt()">
                  <ion-select-option *ngFor="let u of ugyiratok" [value]="u.id">
                    {{ elozmenyCimke(u) }}
                  </ion-select-option>
                </ion-select>
                <ion-note color="medium" *ngIf="!ugyiratok.length && !elozmenyFut">
                  Nincs találat – próbáld az iktatószámmal vagy a tanuló nevével.
                </ion-note>

                <!--  MELYIK IRATHOZ TARTOZIK. Elhagyható: enélkül is az ügyirat következő
                      alszáma lesz, csak nem mutat rá egy konkrét előzményre. -->
                <ion-select label="A küldemény melyik irathoz tartozik? (elhagyható)"
                            label-placement="stacked" interface="popover"
                            *ngIf="kapcsolodoIratok.length" [(ngModel)]="urlap.kapcsolodo_irat">
                  <ion-select-option value="">– nem kötöm konkrét irathoz –</ion-select-option>
                  <ion-select-option *ngFor="let i of kapcsolodoIratok" [value]="i.id">
                    {{ iratCimke(i) }}
                  </ion-select-option>
                </ion-select>
                <ion-note color="medium" *ngIf="urlap.ugyirat && !kapcsolodoIratok.length && !kapcsolodoTolt">
                  Ebben az ügyiratban még nincs irat, amihez kötni lehetne.
                </ion-note>
              </div>
              <ion-textarea label="Tárgy" label-placement="stacked" rows="2" [autoGrow]="true"
                            [(ngModel)]="urlap.targy" style="flex:1 1 100%;max-width:100%"></ion-textarea>
              <ion-input label="Irat vonalkódja" label-placement="stacked" [(ngModel)]="urlap.vonalkod"></ion-input>
              <ion-select label="Adathordozó" label-placement="stacked" interface="popover"
                          [(ngModel)]="urlap.adathordozo">
                <ion-select-option value="papir">papír</ion-select-option>
                <ion-select-option value="elektronikus">elektronikus</ion-select-option>
                <ion-select-option value="vegyes">vegyes</ion-select-option>
              </ion-select>
              <ion-input label="Mellékletek száma" label-placement="stacked" type="number"
                         [(ngModel)]="urlap.melleklet_db"></ion-input>
            </div>

            <h4>Partner (küldő / címzett)</h4>
            <div class="ikt-mezosor">
              <ion-input label="Partner neve" label-placement="stacked" [(ngModel)]="urlap.partner_nev"></ion-input>
              <div style="position:relative;max-width:280px">
                <ion-input label="Partner keresése" label-placement="stacked" placeholder="tanuló, szülő, cég…"
                           [(ngModel)]="partnerKereses" (ionInput)="partnerKeres()"></ion-input>
                <div *ngIf="partnerTalalatok.length" class="ikt-javaslatok">
                  <div class="ikt-javaslat" *ngFor="let p of partnerTalalatok" (click)="partnerValaszt(p)">
                    <b>{{ p.nev }}</b>
                    <span>{{ p.forras === 'tanulo' ? 'tanuló' : (p.forras === 'szulo' ? 'gondviselő'
                           : (p.forras === 'partner' ? 'cég' : 'partnertörzs')) }}</span>
                  </div>
                </div>
              </div>
              <ion-input label="Partner címe" label-placement="stacked" [(ngModel)]="urlap.partner_cim"></ion-input>
            </div>

            <h4>Irattárazási adatok</h4>
            <div class="ikt-mezosor">
              <ion-select class="hosszu-ertek" label="Irattári tételszám" label-placement="stacked" interface="popover" [interfaceOptions]="{ cssClass: 'hosszu-opciok' }"
                          [(ngModel)]="urlap.tetelszam">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let t of terv" [value]="t.tetelszam">
                  {{ t.tetelszam }} – {{ t.megnevezes }}
                </ion-select-option>
              </ion-select>
            </div>

            <h4>Ügyintézés</h4>
            <div class="ikt-mezosor">
              <ion-select label="Ügyintézés típusa" label-placement="stacked" interface="popover"
                          [(ngModel)]="urlap.ugyintezes_tipus">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let t of UGYINTEZES_TIPUSOK" [value]="t">{{ t }}</ion-select-option>
              </ion-select>
            </div>
            <ion-textarea label="Megjegyzés" label-placement="stacked" rows="2" [autoGrow]="true"
                          [(ngModel)]="urlap.megjegyzes"></ion-textarea>
          </div>

          <!-- Jobb oszlop -->
          <div>
            <h4>Iratkezelési adatok</h4>
            <div class="ikt-mezosor">
              <ion-select label="Kézbesítés prioritása" label-placement="stacked" interface="popover"
                          [(ngModel)]="urlap.kezbesites_prioritas">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let p of PRIORITASOK" [value]="p">{{ p }}</ion-select-option>
              </ion-select>
              <ion-select label="Ügyintéző személy" label-placement="stacked" interface="popover"
                          [(ngModel)]="urlap.ugyintezo">
                <ion-select-option value="">– nincs szignálva –</ion-select-option>
                <ion-select-option *ngFor="let u of ugyintezok" [value]="u.azonosito">{{ u.nev }}</ion-select-option>
              </ion-select>
              <ion-input label="Irat határideje" label-placement="stacked" type="date"
                         [(ngModel)]="urlap.hatarido"></ion-input>
              <ion-select label="Irat kategória" label-placement="stacked" interface="popover"
                          [(ngModel)]="urlap.irat_kategoria">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let k of KATEGORIAK" [value]="k">{{ k }}</ion-select-option>
              </ion-select>
              <ion-input label="Hivatkozási szám / idegen szám" label-placement="stacked"
                         [(ngModel)]="urlap.hivatkozasi_szam"></ion-input>
            </div>

            <h4>Iktatási adatok</h4>
            <div class="ikt-mezosor">
              <ion-select label="Biztonsági minősítés" label-placement="stacked" interface="popover"
                          [(ngModel)]="urlap.biztonsagi_minosites">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let m of MINOSITESEK" [value]="m">{{ m }}</ion-select-option>
              </ion-select>
              <ion-select label="Szerelendő ügyirat" label-placement="stacked" interface="popover"
                          *ngIf="mod === 'foszam'" [(ngModel)]="urlap.szerelendo_ugyirat">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let u of ugyiratok" [value]="u.id">
                  {{ u.iktatoszam }} – {{ u.targy }}
                </ion-select-option>
              </ion-select>
              <ion-input label="Irat kelte" label-placement="stacked" type="date"
                         [(ngModel)]="urlap.kelte"></ion-input>
              <ion-input label="Iktatás dátuma" label-placement="stacked" type="date"
                         [(ngModel)]="urlap.iktatva"></ion-input>
            </div>

            <div class="ikt-mezosor">
              <ion-checkbox labelPlacement="end" [checked]="urlap.masolat_hiteles"
                            (ionChange)="urlap.masolat_hiteles = $event.detail.checked">
                Hiteles másolat készült a papírról
              </ion-checkbox>
            </div>
            <ion-note color="medium" style="font-size:.78rem" *ngIf="urlap.masolat_hiteles">
              A Másolatkészítési Szabályzat záradéka és a felbontás magától rákerül a nyilvántartásra.
            </ion-note>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="ful === 'kiegeszito'">
        <ion-textarea label="Feljegyzés az irathoz" label-placement="stacked" rows="4" [autoGrow]="true"
                      [(ngModel)]="urlap.szoveg"></ion-textarea>
        <ion-note color="medium" style="display:block;margin-top:8px;font-size:.8rem">
          A csatolt állományokat, az iratkapcsolatokat és a példányokat iktatás után,
          az irat lapján tudod felvinni – ott már van iktatószám, amihez köthetők.
        </ion-note>
      </ng-container>

      <div class="ikt-gombsor">
        <ion-button size="small" (click)="iktat()" [disabled]="folyamatban">
          <ion-icon slot="start" name="create-outline"></ion-icon>
          {{ folyamatban ? 'Iktatás…' : 'Iktatás' }}
        </ion-button>
        <ion-note color="medium" *ngIf="urlap.erkeztetes" style="font-size:.8rem">
          Érkeztetett küldeményből – iktatás után a sor lezárul.
        </ion-note>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
